// $(document).ready(function() {
//     const links = [
//         { href: '/collections/new-arrivals', label: 'new arrival' },
//         { href: '/collections/best-sellers-1', label: 'Best Seller' },
//         { href: '/collections/master-healer', label: 'master Healer Collection' },
//         { href: '/collections/new-clothing', label: 'New Arrival Clothing Collection' },
//         { href: '/collections/pants-with-pockets', label: 'pants with pockets Collection' },
//         { href: 'https://www.lotusandluna.com/collections/sale/Clothing', label: 'sale Clothing Collection' },
//         { href: 'https://www.lotusandluna.com/collections/sale/Jewelry', label: 'sale Jewelry Collection' },
//         { href: '/products/mystery-pants', label: 'mystery pants Collection' },
//         { href: '/products/mystery-necklace', label: 'mystery necklace Collection' },
//         { href: '/pages/ambassador-program', label: 'ambassador program' },
//         { href: '/pages/desktop_about', label: 'Our Mission' }
//     ];

//     links.forEach(function(link) {
//         $(".mega-menu__content a[href='" + link.href + "']").attr("aria-label", link.label);
//         console.log("Added aria-label for: " + link.label);
//     });

//     $(".newsletter-form.form.is-responsive button.button.button--icon.is-within-form").attr("aria-label", "newsletter submit");
//     console.log("Added aria-label for newsletter submit button");

//     $(".field .control.has-icons-left.has-icons-right.is-relative input.visuallyhidden").attr("aria-label", "Search");
//     $("form.search-form .search__fields input.visuallyhidden").attr("aria-label", "Search");
//     console.log("Added aria-label for search input fields");
// });

// // 3rd party empty label issue
// document.addEventListener("DOMContentLoaded", function() {
//     function checkAndAddClasses() {
//         const checkboxes = document.querySelectorAll('.css-1azurdc');

//         if (checkboxes.length >= 2) {
//             console.log(`Found ${checkboxes.length} elements with the class .css-1azurdc.`);

//             checkboxes.forEach(function(checkbox, index) {
//                 checkbox.classList.add('visually-hidden');
//                 checkbox.textContent = 'checkbox'; 
//                 console.log(`Updated checkbox ${index + 1}: Added class 'visually-hidden' and set text.`);
//             });

//             clearInterval(intervalId);
//             console.log('Stopped checking for .css-1azurdc and added classes/text.');
//         } else {
//             console.log(`Only found ${checkboxes.length} elements with the class .css-1azurdc, continuing to check...`);
//         }
//     }
//     const intervalId = setInterval(checkAndAddClasses, 500);
// });

// // pdp page 3rd party script
// document.addEventListener("DOMContentLoaded", function() {
//     function checkAndAddSpan() {
//         const labels = document.querySelectorAll('.zrx-sticky-atc-select-label');

//         if (labels.length >= 2) {
//             console.log(`Found ${labels.length} elements with the class .zrx-sticky-atc-select-label.`);

//             labels.forEach(function(label, index) {
//                 const span = document.createElement('span');
//                 span.className = 'visually-hidden'; 
//                 span.textContent = 'select label';  
//                 label.appendChild(span);             
//                 console.log(`Added span to label ${index + 1}: Added class 'visually-hidden' and set text.`);
//             });

//             clearInterval(intervalId);
//             console.log('Stopped checking for .zrx-sticky-atc-select-label and added spans.');
//         } else {
//             console.log(`Only found ${labels.length} elements with the class .zrx-sticky-atc-select-label, continuing to check...`);
//         }
//     }

//     const intervalId = setInterval(checkAndAddSpan, 500);
// });

// // Product Gallery Video Thumbnail
// document.addEventListener("DOMContentLoaded", function() {
//     function checkAndAddAltText() {
//         const images = document.querySelectorAll('.product-gallery__video .plyr__video-wrapper img');

//         if (images.length > 0) {
//             console.log(`Found ${images.length} image(s) with the class .product-gallery__video .plyr__video-wrapper img.`);

//             images.forEach(function(image, index) {
//                 image.setAttribute('alt', 'product video'); 
//                 console.log(`Added alt text to image ${index + 1}.`);
//             });

//             clearInterval(intervalId);
//             console.log('Stopped checking for the product video image and added alt text.');
//         } else {
//             console.log('No images found, continuing to check...');
//         }
//     }

//     const intervalId = setInterval(checkAndAddAltText, 500);
// });

// // size chart table
// document.addEventListener("DOMContentLoaded", function() {
//     function checkAndAddSpan() {
//         const headers = document.querySelectorAll('table.ck-table-resized thead tr th:nth-child(1)');

//         if (headers.length > 0) {
//             console.log(`Found ${headers.length} header cell(s) with the selector table.ck-table-resized thead tr th:nth-child(1).`);

//             headers.forEach(function(header, index) {
//                 const span = document.createElement('span');
//                 span.className = 'visually-hidden'; 
//                 span.textContent = 'size chart';    
//                 header.appendChild(span);            
//                 console.log(`Added span to header cell ${index + 1}: Added class 'visually-hidden' and set text.`);
//             });

//             clearInterval(intervalId);
//             console.log('Stopped checking for the header cell and added spans.');
//         } else {
//             console.log('No header cells found, continuing to check...');
//         }
//     }

//     const intervalId = setInterval(checkAndAddSpan, 500);
// });



// // Function to add alt text to images with the specified class
// function addAltTextToYotpoImages() {
//     const images = document.querySelectorAll('.yotpo-right-align-image img'); 
//     let allImagesUpdated = true;

//     images.forEach((img) => {
//         if (!img.alt) { 
//             img.alt = "Two girls enjoying themselves in an outdoor bar setting."; 
//             console.log(`Added alt text to: ${img.src}`); 
//         }
//     });

 
//     allImagesUpdated = Array.from(images).every((img) => img.alt === "Two girls enjoying themselves in an outdoor bar setting.");

//     if (!allImagesUpdated) {
//         setTimeout(addAltTextToYotpoImages, 1000); 
//     } else {
//         console.log("All specified images have been updated with alt text.");
//     }
// }

// addAltTextToYotpoImages();

// function checkAndAddSpan() {
//     // Check if the element with class 'zrx-sticky-atc-select-label' exists
//     const elements = document.querySelectorAll('.zrx-sticky-atc-select-label');

//     if (elements.length > 0) {
//         elements.forEach((element) => {
//             if (!element.querySelector('span.visually-hidden')) {
//                 const span = document.createElement('span'); 
//                 span.classList.add('visually-hidden'); 
//                 span.textContent = "sticky add to cart";
//                 element.appendChild(span); 
//                 console.log("Added span to:", element); 
//             }
//         });

//         console.log("All elements with the class 'zrx-sticky-atc-select-label' have been updated.");
//     } else {

//         console.log("Class 'zrx-sticky-atc-select-label' not found yet, checking again...");
//         setTimeout(checkAndAddSpan, 1000); 
//     }
// }

// // Start the process
// checkAndAddSpan();

// // css
// function checkAndApplyStyles() {
//     const subheadingElement = document.querySelector('.shopify-section section.section.custom-product-promo.is-width-standard .product-7200246530147 .product__information.two-fifths.column.medium-down--one-whole .product-form-container div#text_container span#subheading');
//     const titleElement = document.querySelector('.shopify-section section.section.custom-product-promo.is-width-standard .product-7200246530147 .product__information.two-fifths.column.medium-down--one-whole .product-form-container div#text_container span#title');

//     if (subheadingElement && titleElement) {
//         subheadingElement.style.color = "#667393";
//         subheadingElement.style.setProperty('color', '#667393', 'important');
//         titleElement.style.color = "#667393";
//         titleElement.style.setProperty('color', '#667393', 'important');

//         console.log("Styles applied to both elements.");
//     } else {
//         console.log("Elements not found yet, checking again...");
//         setTimeout(checkAndApplyStyles, 1000); 
//     }
// }

// // Start the function
// checkAndApplyStyles();
// // end here

// function checkAndAddAltText() {
//     // Select all images within the given selector
//     const images = document.querySelectorAll('.yotpo-vip-tiers-grid-container .yotpo-grid-vip-tier img');

//     // Check if images are found
//     if (images.length > 0) {
//         images.forEach(function(image) {
//             // Check if the alt text has already been added to avoid duplication
//             if (!image.hasAttribute('alt') || image.getAttribute('alt') === '') {
//                 image.setAttribute('alt', 'reward image'); // Set the alt attribute
//                 console.log("Added alt text to an image:", image); // Log the updated image
//             }
//         });

//         // Check if all images have the alt text set, if not, keep checking
//         const allImagesUpdated = Array.from(images).every(image => image.getAttribute('alt') === 'reward image');
//         if (!allImagesUpdated) {
//             console.log("Not all images updated yet, checking again...");
//             setTimeout(checkAndAddAltText, 1000); // Retry every 1 second if any image is still missing the alt text
//         } else {
//             console.log("All images have been updated with alt text.");
//         }
//     } else {
//         // If no images are found, keep checking every second
//         console.log("Images not found yet, checking again...");
//         setTimeout(checkAndAddAltText, 1000); // Retry every 1 second
//     }
// }

// // Start the function
// checkAndAddAltText();

// // end here
// function checkAndAddAltTextToRightAlignImage() {
//     // Select the image with the given class
//     const image = document.querySelector('.yotpo-background.yotpo-right-align-background img.yotpo-right-align-image');

//     // Check if the image is found
//     if (image) {
//         // Check if the alt text has already been added to avoid duplication
//         if (!image.hasAttribute('alt') || image.getAttribute('alt') === '') {
//             // Set the alt attribute with rephrased text
//             image.setAttribute('alt', 'Two women sitting outdoors enjoying drinks at a bar');
//             console.log("Added alt text to the image:", image); // Log the update
//         }
//     } else {
//         // If the image is not found, keep checking every second
//         console.log("Image not found yet, checking again...");
//         setTimeout(checkAndAddAltTextToRightAlignImage, 1000); // Retry every 1 second
//     }
// }

// // Start the function
// checkAndAddAltTextToRightAlignImage();
// //  end here

$(document).ready(function () {
    // List of links to add aria-labels to
    const links = [
        { href: '/collections/new-arrivals', label: 'new arrival' },
        { href: '/collections/best-sellers-1', label: 'Best Seller' },
        { href: '/collections/master-healer', label: 'master Healer Collection' },
        { href: '/collections/new-clothing', label: 'New Arrival Clothing Collection' },
        { href: '/collections/pants-with-pockets', label: 'pants with pockets Collection' },
        { href: 'https://www.lotusandluna.com/collections/sale/Clothing', label: 'sale Clothing Collection' },
        { href: 'https://www.lotusandluna.com/collections/sale/Jewelry', label: 'sale Jewelry Collection' },
        { href: '/products/mystery-pants', label: 'mystery pants Collection' },
        { href: '/products/mystery-necklace', label: 'mystery necklace Collection' },
        { href: '/pages/ambassador-program', label: 'ambassador program' },
        { href: '/pages/desktop_about', label: 'Our Mission' }
    ];

    // Add aria-label to all specified links
    links.forEach(link => {
        const selector = `.mega-menu__content a[href='${link.href}']`;
        $(selector).attr("aria-label", link.label);
        console.log(`Added aria-label for: ${link.label}`);
    });

    // Add aria-labels to the newsletter form and search inputs
    $(".newsletter-form.form.is-responsive button.button.button--icon.is-within-form").attr("aria-label", "newsletter submit");
    console.log("Added aria-label for newsletter submit button");

    $("input.visuallyhidden").attr("aria-label", "Search");
    console.log("Added aria-label for search input fields");
});

// Generic function to continuously check for elements and run a callback when found
function checkAndExecute(selector, callback, interval = 500) {
    const intervalId = setInterval(() => {
        const elements = document.querySelectorAll(selector);
        if (elements.length > 0) {
            callback(elements);
            clearInterval(intervalId);
            console.log(`Stopped checking for ${selector} after successful execution.`);
        } else {
            console.log(`Still looking for ${selector}, retrying...`);
        }
    }, interval);
}

// Add visually hidden class and text to elements with .css-1azurdc
checkAndExecute('.css-1azurdc', (elements) => {
    elements.forEach((checkbox, index) => {
        checkbox.classList.add('visually-hidden');
        checkbox.textContent = 'checkbox';
        console.log(`Updated checkbox ${index + 1}: Added 'visually-hidden' class and text.`);
    });
});

// Add span to .zrx-sticky-atc-select-label elements
checkAndExecute('.zrx-sticky-atc-select-label', (elements) => {
    elements.forEach((label, index) => {
        const span = document.createElement('span');
        span.className = 'visually-hidden';
        span.textContent = 'sticky add to cart';
        label.appendChild(span);
        console.log(`Added span to label ${index + 1}: 'sticky add to cart'.`);
    });
});

// Add alt text to video thumbnails in product gallery
checkAndExecute('.product-gallery__video .plyr__video-wrapper img', (images) => {
    images.forEach((image, index) => {
        image.setAttribute('alt', 'product video');
        console.log(`Added alt text to image ${index + 1}.`);
    });
});

// Add span to table headers
checkAndExecute('table.ck-table-resized thead tr th:nth-child(1)', (headers) => {
    headers.forEach((header, index) => {
        const span = document.createElement('span');
        span.className = 'visually-hidden';
        span.textContent = 'size chart';
        header.appendChild(span);
        console.log(`Added span to header ${index + 1}: 'size chart'.`);
    });
});

// Add alt text to Yotpo VIP tier images
checkAndExecute('.yotpo-vip-tiers-grid-container .yotpo-grid-vip-tier img', (images) => {
    images.forEach((image) => {
        if (!image.alt) {
            image.setAttribute('alt', 'reward image');
            console.log(`Added alt text to image: ${image.src}`);
        }
    });
});

// Add alt text to Yotpo right-align images
checkAndExecute('.yotpo-background.yotpo-right-align-background img.yotpo-right-align-image', (images) => {
    images.forEach((image) => {
        if (!image.alt) {
            image.setAttribute('alt', 'Two women sitting outdoors enjoying drinks at a bar');
            console.log('Added alt text to right-align image');
        }
    });
});

// Apply CSS styles to elements
checkAndExecute(
    '.shopify-section .product-7200246530147 .product-form-container div#text_container span#subheading, ' +
    '.shopify-section .product-7200246530147 .product-form-container div#text_container span#title',
    (elements) => {
        elements.forEach((element) => {
            element.style.color = "#667393";
            element.style.setProperty('color', '#667393', 'important');
            console.log("Applied styles to element:", element);
        });
    }
);
//end here


// Function to continuously check for the input element and remove aria-describedby
function checkAndRemoveAriaDescribedBy() {
    const inputElement = document.querySelector('.yotpo-input-container.yotpo-email-container input');

    if (inputElement) {
        // Check if the aria-describedby attribute exists
        if (inputElement.hasAttribute('aria-describedby')) {
            inputElement.removeAttribute('aria-describedby');
            console.log('Removed aria-describedby from input element:', inputElement);
        } else {
            console.log('aria-describedby attribute not found on the input element.');
        }
    } else {
        console.log('Input element not found yet, checking again...');
        setTimeout(checkAndRemoveAriaDescribedBy, 1000); // Retry every second
    }
}

const checkElement = setInterval(() => {
    const secondSpan = document.querySelector('.nosto-item.nosto-info-container a.nosto-price.quick-shop span:nth-child(2)');
    if (secondSpan) {
        secondSpan.classList.add('your-new-class'); // Replace 'your-new-class' with the desired class name
        console.log('Class added to the second span.');
        clearInterval(checkElement); // Stop checking once the element is found
    }
}, 100); // Check every 100 milliseconds


// a11y (WCAG 2.4.3 Focus Order): manage focus for the Klaviyo discount popup.
// Klaviyo renders the popup as role="dialog" aria-modal="true" with a focus
// trap, but it focuses its own close button during the open animation. In a real
// browser that .focus() silently no-ops (the element isn't focusable yet), so
// focus is left on <body>: the dialog never announces and aria-modal strands the
// user behind it. (Headless automation fakes page focus, so it cannot reproduce
// this; only a real browser / screen reader can. Proof of record is a manual SR
// pass, not the Playwright suite.)
//
// Once the dialog is rendered we move focus to its first interactive field. Per
// the ARIA APG and Adrian Roselli's screen-reader matrix, focusing an element
// INSIDE the dialog is the only target that reliably announces "dialog" across
// NVDA/JAWS/VoiceOver; focusing the container does not (NVDA omits the role and
// over-reads). Klaviyo's generic "POPUP Form" name is replaced with a meaningful
// one, and focus is restored on close. Selector self-scopes to modals: non-modal
// flyouts/embeds lack aria-modal and are intentionally left alone.
(function () {
    var MODAL = '[role="dialog"][aria-modal="true"]';
    // Stable, promo-copy-independent accessible name. The popup's headline is
    // non-semantic (no heading element to reference), and the discount % changes
    // with campaigns, so a fixed descriptive name is the robust choice. Edit here
    // if the form's purpose changes.
    var DIALOG_NAME = 'Email sign-up offer';

    // The dialog node can lag the 'open' event; poll briefly. Bounded to ~1s so a
    // non-modal flyout's 'open' (which never matches MODAL) cannot loop forever.
    function whenModalReady(callback) {
        var tries = 0;
        (function look() {
            var modal = document.querySelector(MODAL);
            if (modal) { callback(modal); return; }
            if (++tries > 10) return;
            setTimeout(look, 100);
        })();
    }

    function focusInto(modal) {
        // Give the dialog a meaningful name if it only carries Klaviyo's generic one.
        var name = modal.getAttribute('aria-label');
        if (!name || /^popup form$/i.test(name.trim())) {
            modal.setAttribute('aria-label', DIALOG_NAME);
        }
        // Prefer the email field; fall back to any real form control, then (last
        // resort) the container. Never the close button, which is what we are
        // moving focus away from.
        var field = modal.querySelector('input[type="email"]')
            || modal.querySelector('input:not([type="hidden"]):not([type="submit"]):not([type="button"]), select, textarea');
        if (!field) {
            modal.setAttribute('tabindex', '-1');
            field = modal;
        }
        field.focus();
    }

    // Reset focus to the top of the page so the next Tab lands on the skip-to-content
    // link (the first focusable element), mirroring a fresh page load. Uses a hidden
    // tabindex=-1 sentinel inserted before the skip link, because blur()/body.focus()
    // are browser-inconsistent for "next Tab = first focusable" (MDN, web.dev). The
    // sentinel is tabindex=-1, so it is not itself a Tab stop and the skip link stays
    // the first one.
    function sendFocusToTop() {
        var s = document.getElementById('a11y-top-sentinel');
        if (!s) {
            s = document.createElement('div');
            s.id = 'a11y-top-sentinel';
            s.tabIndex = -1;
            s.className = 'visually-hidden'; // existing utility; stays hidden when focused
            document.body.insertBefore(s, document.body.firstChild);
        }
        s.focus();
    }

    // On close, Klaviyo moves focus onto its teaser and it sticks. React to that move
    // (focusin bubbles, so one document listener catches it) and send focus back to
    // the top. Remove the listener before re-focusing so our own change can't
    // re-trigger it; tear down after a short window, which also lifts focus out of the
    // hidden dialog in the no-teaser case.
    function manageCloseFocus() {
        var done = false;
        function teardown() { done = true; document.removeEventListener('focusin', onFocusIn); }
        function onFocusIn(e) {
            if (done) return;
            if (e.target && e.target.closest && e.target.closest('[class*="Teaser"]')) {
                teardown(); // remove before re-focusing, so we don't re-trigger
                sendFocusToTop();
            }
        }
        document.addEventListener('focusin', onFocusIn);
        setTimeout(function () {
            if (done) return;
            teardown();
            if (document.activeElement && document.activeElement.closest(MODAL)) sendFocusToTop();
        }, 1500);
    }

    window.addEventListener('klaviyoForms', function (e) {
        if (!e || !e.detail) return;
        if (e.detail.type === 'open') {
            whenModalReady(focusInto);
        } else if (e.detail.type === 'close') {
            manageCloseFocus();
        }
    });
})();




